import { INTENT } from '../../../../utils/selfScheduleHandoff';

// The handoff intents plus `quote`, which never reaches the self-schedule app
// today: it resolves on this side to the legacy Custom Quote page (WEBDEV-4259).
// Kept out of selfScheduleHandoff's INTENT because the app's reader rejects
// unknown intents and falls back to a plain Step 1 start.
export const ON_PAGE_INTENT = {
    ...INTENT,
    quote: 'quote',
} as const;
export type OnPageIntent = (typeof ON_PAGE_INTENT)[keyof typeof ON_PAGE_INTENT];

export interface OnPageSelfScheduleFormValues {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    // Which button was clicked ('schedule' | 'question' | 'quote'), set via
    // setFieldValue on the button's onClick before the real Formik submit runs —
    // mirrors ConsultationForm's consultType pattern.
    intent: OnPageIntent | '';
}

export const onPageSelfScheduleInitialValues: OnPageSelfScheduleFormValues = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    intent: '',
};
